import React from "react";
import { steps } from "../../data/homepageData";

export const HowItWorks = () => (
  <section id="how-it-works" className="py-20 bg-slate-900/50">
    <div className="mx-auto max-w-7xl px-6">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold">
          How It
          <span className="text-cyan-400"> Works</span>
        </h2>
        <p className="mt-4 text-slate-400 max-w-2xl mx-auto">
          A simple, transparent process from start to finish.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
        {steps.map((step, index) => (
          <div key={step.id} className="relative">
            {index < steps.length - 1 && (
              <div className="hidden lg:block absolute top-8 left-full w-full h-0.5 bg-gradient-to-r from-cyan-500/50 to-transparent" />
            )}
            <div className="text-5xl font-bold text-cyan-500/20 mb-4">{step.number}</div>
            <h3 className="text-lg font-semibold mb-2">{step.title}</h3>
            <p className="text-slate-400 text-sm leading-relaxed">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
